<h2 id="pony-references">What are pony references?</h2>

<p>Pony references are a high level way of classifying how much MLP/brony source material is incorporated into a track. There are three classifications: Obvious Refs, Subtle Refs, and No Refs</p>

<ul><li>
		Obvious refs is for tracks which make heavy use of source material, likely to the point someone not familiar with My Little Pony could pick up that it's pony related. This includes
		<ul>
			<li>Remixes of show songs</li>
			<li>Songs w/ lyrics directly about MLP or brony culture</li>
			<li>Songs which use extensive chops of clips from the show</li>
		</ul>
		Examples of obvious ref songs include
		<ul>
			<li>Discord by Eurobeat Brony</li>
		</ul>
	</li>
	<li>
		Subtle refs is for tracks which build upon source material, but in a way that people not familiar with MLP would likely not pick up on. Most fans, however, would see the connection.
		<ul>
			<li>Pieces with melodic references to show songs</li>
			<li>Songs with lyrics that fit the pony context without explicilty mentioning names/events/etc. from the show/fandom.</li>
			<li>Obscure chops that aren't easily identified as originanting from the show/fandom</li>
		</ul>
	</li>
	<li>
		No refs is for tracks which don't reference any material from the show/fandom - it is still pony music, but you wouldn't have any way of telling just listening to the track alone
	</li>
</ul>

<style>
	p, ul, h2{
	margin-top: 0px;
}
</style>